import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fractions-intro',
  templateUrl: './fractions-intro.component.html',
  styleUrls: ['./fractions-intro.component.css']
})
export class FractionsIntroComponent implements OnInit {

  equation: string = '\\sum_{i=1}^nx_i';
  nOverD: string = '\\frac{taeller}{naevner}';
  aOverB: string = '\\frac{a}{b}';
  oneOver2: string = '\\frac{1}{2}';
  oneOver3: string = '\\frac{1}{3}';
  threeOver6: string = '\\frac{3}{6}';
  sixteen: string = '16';  
  sixteenE28: string = '16 = 2 * 8';
  sixteenE44: string = '16 = 4 * 4';
  zeroPoint5: string = '0,5';
  zeroPoint33: string = '0,3333333333...';
  fracExtend: string = '\\frac{a}{b} = \\frac{a*c}{b*c}';
  fracExtendEx: string = '\\frac{1}{2} = \\frac{1*3}{2*3} = \\frac{3}{6}';
  fracExtendEx2: string = '\\frac{6}{8} = \\frac{3*2}{4*2} = \\frac{3}{4}';
  fracAddSimple: string = '\\frac{a}{b} + \\frac{c}{b} = \\frac{a + c}{b}';
  fracAddSimpleEx: string = '\\frac{1}{4} + \\frac{2}{4} = \\frac{1 + 2}{4} = \\frac{3}{4}';
  fracAdd: string = '\\frac{a}{b} + \\frac{c}{d} = \\frac{a*d}{b*d} + \\frac{b*c}{b*d} = \\frac{(a*d) + (c*b)}{b*d}';
  fracAddEx: string = '\\frac{1}{4} + \\frac{1}{3} = \\frac{1*3}{4*3} + \\frac{4*1}{4*3} = \\frac{3}{12} + \\frac{4}{12} = \\frac{3 + 4}{12} = \\frac{7}{12}';
  fracMinusSimple: string = '\\frac{a}{b} - \\frac{c}{b} = \\frac{a - c}{b}';
  fracMinus: string = '\\frac{a}{b} - \\frac{c}{d} = \\frac{a*d}{b*d} - \\frac{b*c}{b*d} = \\frac{(a*d) - (c*b)}{b*d}';
  fracMinusEx: string = '\\frac{1}{3} + \\frac{1}{4} = \\frac{1*4}{4*3} + \\frac{3*1}{4*3} = \\frac{4}{12} + \\frac{3}{12} = \\frac{4 - 3}{12} = \\frac{1}{12}';
  acOverBC: string = '\\frac{a*c}{b*c}';
  fracMult: string = '\\frac{a}{b} * \\frac{c}{d} = \\frac{a * c}{b * d}';
  fracMultEx: string = '\\frac{1}{4} + \\frac{2}{3} = \\frac{1 * 2}{4 * 3} = \\frac{2}{12} = \\frac{1}{6}';
  fracMultNumber: string = 'a + \\frac{c}{d} = \\frac{a*c}{d}';
  fracMultNumberEx: string = '2 * \\frac{1}{3} = \\frac{2*1}{3} = \\frac{2}{3}';
  fracDiv: string = '\\frac{a}{b} : \\frac{c}{d} = \\frac{a}{b} * \\frac{d}{c} = \\frac{a * d}{b * c}';
  fracDivEx: string = '\\frac{1}{4} : \\frac{2}{3} = \\frac{1}{4} * \\frac{3}{2} = \\frac{1 * 3}{4 * 2} = \\frac{3}{8}';
  fracDivNumber: string = 'a : \\frac{c}{d} = a : \\frac{d}{c} = \\frac{a*d}{c}';
  fracDivNumberEx: string = '2 : \\frac{2}{3} = 2 * \\frac{3}{2} = \\frac{2*3}{2} = \\frac{6}{2} = 3';

  constructor() {}

  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/fractions-intro/fractions-intro.component.ts